import axios from "../api/axios";

/**
 * @author : Amol Rathod
 *
 * @description : This function sends a POST request to the server to store a set of generated questions, associated with a specific document and user email. The questions to be saved include short questions, multiple-choice questions (MCQs), fill-in-the-blank questions (FIBs), interpretive questions, and additional notes. The server is expected to handle the storage and association of these questions in its database.
 */

/**
 * @param {object} generateQuestions - An object containing the generated questions, including short questions, MCQs, FIBs, interpretive questions, and notes.
 * @param {string} docId - The unique identifier of the document for which the questions are generated.
 * @param {string} email - The email address of the user responsible for generating and saving the questions.
 * @returns {Promise<object>} - A Promise that resolves to the response from the server, indicating the success or status of the save operation.
 * @throws {Error} - If an error occurs during the API request or processing on the server-side.
 */
export const saveQuestions = async (
  short_questions,
  mcqs_questions,
  true_false_questions,
  fib_questions,
  // descriptive_questions,
  interpretive_questions,
  notes,
  doc_id,
  email,
  title,
  totalQues,
  user
) => {
  try {
    if (user.isGPT){
      var filteredShortQuestions = short_questions;
    // Filter out any short_questions that are also in descriptive_questions
    // const descriptiveQuestionsTextSet = new Set(
    //   descriptive_questions.map((q) => (q.question || q.Question || "").trim().toLowerCase())
    // );

    // var filteredShortQuestions = short_questions.filter(
    //   (q) => !descriptiveQuestionsTextSet.has((q.question || q.Question || "").trim().toLowerCase())
    // );
    }else {
      // const descriptiveQuestionsTextSet = new Set(
      //   descriptive_questions.map((q) => (q.question || q.Question || "").trim().toLowerCase())
      // );
  
      // var filteredShortQuestions = short_questions.filter(
      //   (q) => !descriptiveQuestionsTextSet.has((q.question || q.Question || "").trim().toLowerCase())
      // );
      // If user is not GPT, use the original short_questions
      var filteredShortQuestions = short_questions;
    }
    // logic for calculating total values of the questions .
    const totalQuestions =
    (filteredShortQuestions?.length || 0) +
    (mcqs_questions?.length || 0) +
    (true_false_questions?.length || 0) +
    (fib_questions?.length || 0) +
    // (descriptive_questions?.length || 0) +
    (interpretive_questions?.length || 0);


    const token = localStorage.getItem("token"); 
    const content = localStorage.getItem("content");

    const payload = {
      "document": [
        {
          "doc_id":doc_id,
          "title":title,
          "questions_data":{
            "questionset" :{
              "questionset": {
              short_questions: { questions: user.isGPT ? filteredShortQuestions : filteredShortQuestions },
              mcqs_questions: { questions: mcqs_questions },
              true_false_questions: { questions: true_false_questions },
              fib_questions: { questions: fib_questions },
              // descriptive_questions: { questions: descriptive_questions },
              interpretive_questions: { questions: interpretive_questions },
              "notes":notes,
              "email":email,
              no_ques: totalQuestions
              }
            }
          }
        }
      ]
    }

    let document = payload.document

    // Send a POST request to save questions.
    const response = await axios.post("/save_QuestionAnswer", {
      document
    },{
      headers:{
        Authorization : `Bearer ${token}`
      }
   });

    // Return the response object from the server.
    return response; // You can handle the response as needed.
  } catch (error) {
    // If an error occurs during the API request, re-throw the error.
    throw error;
  }
};
